import { ReactNode, RefObject } from 'react'
import ReactDOM from 'react-dom'
import { StyledRightColumn } from 'routes/ChatRouteLayout'
import { useSettingsPortal } from './useSettingsPortal'

const SettingsPortal = ({
    children,
    portalRef,
}: {
    children: ReactNode
    portalRef: RefObject<HTMLElement>
}) => {
    const { isVisible } = useSettingsPortal({ portalRef })

    return (
        <>
            {isVisible &&
                document.getElementById('right-column-portal-target') &&
                ReactDOM.createPortal(
                    <StyledRightColumn>{children}</StyledRightColumn>,
                    document.getElementById('right-column-portal-target') as Element,
                )}
        </>
    )
}

export default SettingsPortal
